import React, { Component } from 'react';
import {
  Button,
  Dropdown,
  Icon,
  Popup,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../../constants/translation';

class SortButton extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      icon: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
      ]),
      sortColumn: PropTypes.string,
      sortDirection: PropTypes.string,
      href: PropTypes.string,
      target: PropTypes.string,
      rel: PropTypes.string,
      isDivider: PropTypes.bool,
      onClick: PropTypes.func,
      dataTarget: PropTypes.string,
      tooltip: PropTypes.string,
    })).isRequired,
    icon: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.node,
      PropTypes.string,
    ]),
    loading: PropTypes.bool,
    color: PropTypes.string,
    onSort: PropTypes.func,
    floated: PropTypes.string,
    className: PropTypes.string,
    header: PropTypes.string,
    disabled: PropTypes.bool,
    t: PropTypes.func,
  }
  shouldComponentUpdate(nextProps) {
    if ((this.props.items !== nextProps.items) ||
    (this.props.icon !== nextProps.icon) ||
    (this.props.color !== nextProps.color) ||
    (this.props.loading !== nextProps.loading)) {
      return true;
    }
    return false;
  }
  getDataAttributes = (datarget) => {
    if (datarget !== '') {
      return {
        'data-bot-target': datarget,
      };
    }
    return '';
  }
  handleOnSort = (column, direction) => {
    if (this.props.onSort) {
      this.props.onSort(column, direction);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Button.Group floated={this.props.floated} className={this.props.className}>
        <Dropdown
          basic
          icon={this.props.icon}
          floating
          scrolling
          disabled={this.props.loading || this.props.disabled}
        >
          <Dropdown.Menu>
            {
              this.props.header ? <Dropdown.Header content={this.props.header} /> : null
            }
            {
              this.props.items && this.props.items.length > 0 ?
              this.props.items.map((item, idx) => {
                if (item.isDivider) {
                  return <Dropdown.Divider key={idx} />;
                }
                const dropdownItem = (
                  <Dropdown.Item
                    {...this.getDataAttributes(item.dataTarget)}
                    key={idx}
                    as={item.href ? 'a' : null}
                    text={t(item.text)}
                    icon={item.icon}
                    href={item.href || null}
                    target={item.href && item.target ? item.target : null}
                    rel={item.href && item.rel ? item.rel : null}
                    onClick={() => {
                      if (!item.href) {
                        if (item.onClick) {
                          return item.onClick();
                        }
                        return this.handleOnSort(item.sortColumn, item.sortDirection);
                      }
                      return null;
                    }}
                  />
                );
                if (!item.tooltip) {
                  return dropdownItem;
                }
                return (
                  <Popup
                    key={idx}
                    trigger={dropdownItem}
                    content={item.tooltip}
                    size="mini"
                    position="left center"
                    inverted
                  />
                );
              }) : null
            }
          </Dropdown.Menu>
        </Dropdown>
      </Button.Group>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.translation)(SortButton);



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCSortButton.jsx